import { render, staticRenderFns } from "./ResourceListSearch.vue?vue&type=template&id=ac8ad810&scoped=true"
import script from "./ResourceListSearch.vue?vue&type=script&lang=js"
export * from "./ResourceListSearch.vue?vue&type=script&lang=js"
import style0 from "./ResourceListSearch.vue?vue&type=style&index=0&id=ac8ad810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8ad810",
  null
  
)

export default component.exports